var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "router-link",
        {
          staticClass: "link",
          attrs: { to: { name: _vm.link, novelId: _vm.novelId } },
        },
        [
          _c("div", [_vm._t("default")], 2),
          _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }